import React, { FC, ReactElement, ReactNode } from 'react'

import { useIntl } from 'react-intl'

import { Button, Typography, useTheme } from '@themenu/design-system'

import { PageTitle } from '@app/components/Shared/PageTitle'
import { InvitationContentLayout, InvitationFlowLayout } from '@app/layout/InvitationLayout'

export const NotFoundPage: FC = (): ReactElement => {
  const { formatMessage } = useIntl()
  const theme = useTheme()

  return (
    <InvitationFlowLayout showBackButton={false}>
      <PageTitle title={formatMessage({ id: 'not_found_page.page_title' })} />
      <div className="flex w-full flex-1 flex-col justify-between gap-24 px-20 pb-32 xs:flex-none xs:px-0 xs:pb-0">
        <InvitationContentLayout>
          <div>
            <div className="mb-24">
              <Typography variant="largeTitle">
                {formatMessage(
                  { id: 'not_found_page.new_title' },
                  {
                    strong: (text: ReactNode) => (
                      <Typography variant="largeTitle" component="span" color={theme.colors.title.red} display="inline">
                        {text}
                      </Typography>
                    ),
                  },
                )}
              </Typography>
            </div>
            <div className="w-full">
              <Typography variant="body">{formatMessage({ id: 'not_found_page.subtitle' })}</Typography>
            </div>
          </div>
        </InvitationContentLayout>
        <Button component="a" href="/" size={48} width="100%">
          {formatMessage({
            id: 'error_page.back',
          })}
        </Button>
      </div>
    </InvitationFlowLayout>
  )
}
